// /frontend/src/api/reports.js
import api from '@/services/api';

export const reportsApi = {
    /**
     * params: { studentId: number, date: 'YYYY-MM-DD' }
     */
    getStudentDaily(params) {
        return api.get('/reports/daily/student', { params });
    },

    /**
     * DELETE /students/{studentId}/daily/{date}/presence
     * params: { studentId: number, date: 'YYYY-MM-DD' }
     */
    deleteStudentDailyPresence(params) {
        const sid = Number(params?.studentId);
        const date = String(params?.date || '').trim();
        return api.delete(`/students/${encodeURIComponent(sid)}/daily/${encodeURIComponent(date)}/presence`);
    }
};